import { showElement, hideElement } from '@src/shared/element';
import { ref } from 'vue';

export const pageLoadingVisible = ref(true);
export const showPageLoading = () => {
	if (pageLoadingVisible.value) return;
	showElement(document.getElementById('app-loading'));
	pageLoadingVisible.value = true;
};

export const hidePageLoading = () => {
	if (pageLoadingVisible.value !== true) return;
	hideElement(document.getElementById('app-loading'));
	pageLoadingVisible.value = false;
};
